import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  pageData: {},
  pageFlag: 'create'
}

export const modelCategorySlice = createSlice({
  name: 'modelCategory',
  initialState,
  reducers: {
    // 自动生成 action creator 和 reducer
    setModelCategoryDataAction: (state, action) => {
      state.pageData = action.payload
    },
    setModelCategoryPageFlagAction: (state, action) => {
      state.pageFlag = action.payload
    },
  }
})

// 自动生成的 action creators
export const { setModelCategoryDataAction, setModelCategoryPageFlagAction } = modelCategorySlice.actions

// Selectors
export const selectModelCategoryData = (state) => state.modelCategory.pageData
export const selectModelCategoryPageFlag = (state) => state.modelCategory.pageFlag

// Reducer
export default modelCategorySlice.reducer